export const ENGAGEMENT_PINNED = 'ENGAGEMENT_PINNED';
export const OPEN_REPLACE_PINNED_ENGAGEMENT_MODAL = 'OPEN_REPLACE_PINNED_ENGAGEMENT_MODAL';